// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Shalani Chethana
 * @Date 22/01/2025
 */

.navBar_appBar__B81wD {
    font-family:Verdana, Geneva, Tahoma, sans-serif;
    background-color: #000000;
    color: rgb(255, 255, 255);
    padding: 20px 100px 0px 100px;
}

.navBar_toolBar__jHcgH {
    flex-grow: 1;
}

.navBar_logo__VE1zO {
    width: 6.5rem;
    height: 2.5rem;
    align-items: flex-start;
}
.navBar_listItemMenu__Ciq\\+W{
    color: rgb(252, 252, 252);
    font-size: 1rem;
    font-style: normal;
    font-weight: 500;  
}

.navBar_listItem__2TkeY:active, .navBar_listItem__2TkeY:hover, .navBar_listItem__2TkeY:focus, .navBar_listItemMenu__Ciq\\+W:active, .navBar_listItemMenu__Ciq\\+W:hover, .navBar_listItemMenu__Ciq\\+W:focus  , .navBar_subListItem__ns4hH:focus , .navBar_subListItem__ns4hH:hover{
    color: #4fcdff;
}

/* for mobile */
@media (max-width: 770px) {
    .navBar_menuContainer__6EM2v {
        width: 15rem;
    }
    .navBar_appBar__B81wD {
        font-family:Verdana, Geneva, Tahoma, sans-serif;
        margin-top: 0px;
    }

    .navBar_image__01ctI {
        width: fit-content;
        height: 2.5rem;
        margin-left: 1rem;
        margin-top: 1rem;
    }

    .navBar_list__BpLCf {
        display: none;
    }

    .navBar_listItem__2TkeY {
        margin: 1rem;
    }
    .navBar_appBar__B81wD{
        padding: 20px 20px 0px 20px;
    }
    .navBar_logo__VE1zO {
        width: 4.5rem;
        height: 1.5rem;
    }
}

@media (min-width: 771px) {
    .navBar_menu__f-fuw {
        display: none;
    }
    .navBar_list__BpLCf {
        display: flex;
        flex-grow: 1;     
    }

    .navBar_listItem__2TkeY {
        margin-left: 2.5rem;
        margin-top: 1.5rem;
        margin-bottom: 1rem;
        color: #f7f6f6;
        font-size: 1rem;
        font-style: normal;
        font-weight: 500;
    }
  
    .navBar_subListItem__ns4hH{
        margin-left: 2.5rem;
        margin-top: 1.5rem;
        margin-bottom: 1rem;
        color: #f7f6f6;
        font-size: 0.5rem;
        font-style: normal;
        font-weight: 500;
    }
    .navBar_listItem__2TkeY:active, .navBar_listItem__2TkeY:hover, .navBar_listItem__2TkeY:focus, .navBar_listItemMenu__Ciq\\+W:active, .navBar_listItemMenu__Ciq\\+W:hover, .navBar_listItemMenu__Ciq\\+W:focus {
        color: #4fcdff;
    }
}

`, "",{"version":3,"sources":["webpack://./src/components/navBar/navBar.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;AAEF;IACI,+CAA+C;IAC/C,yBAAyB;IACzB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,uBAAuB;AAC3B;AACA;IACI,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA,eAAe;AACf;IACI;QACI,YAAY;IAChB;IACA;QACI,+CAA+C;QAC/C,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,cAAc;QACd,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,aAAa;QACb,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,mBAAmB;QACnB,cAAc;QACd,eAAe;QACf,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,mBAAmB;QACnB,cAAc;QACd,iBAAiB;QACjB,kBAAkB;QAClB,gBAAgB;IACpB;IACA;QACI,cAAc;IAClB;AACJ","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Shalani Chethana\r\n * @Date 22/01/2025\r\n */\r\n\r\n.appBar {\r\n    font-family:Verdana, Geneva, Tahoma, sans-serif;\r\n    background-color: #000000;\r\n    color: rgb(255, 255, 255);\r\n    padding: 20px 100px 0px 100px;\r\n}\r\n\r\n.toolBar {\r\n    flex-grow: 1;\r\n}\r\n\r\n.logo {\r\n    width: 6.5rem;\r\n    height: 2.5rem;\r\n    align-items: flex-start;\r\n}\r\n.listItemMenu{\r\n    color: rgb(252, 252, 252);\r\n    font-size: 1rem;\r\n    font-style: normal;\r\n    font-weight: 500;  \r\n}\r\n\r\n.listItem:active, .listItem:hover, .listItem:focus, .listItemMenu:active, .listItemMenu:hover, .listItemMenu:focus  , .subListItem:focus , .subListItem:hover{\r\n    color: #4fcdff;\r\n}\r\n\r\n/* for mobile */\r\n@media (max-width: 770px) {\r\n    .menuContainer {\r\n        width: 15rem;\r\n    }\r\n    .appBar {\r\n        font-family:Verdana, Geneva, Tahoma, sans-serif;\r\n        margin-top: 0px;\r\n    }\r\n\r\n    .image {\r\n        width: fit-content;\r\n        height: 2.5rem;\r\n        margin-left: 1rem;\r\n        margin-top: 1rem;\r\n    }\r\n\r\n    .list {\r\n        display: none;\r\n    }\r\n\r\n    .listItem {\r\n        margin: 1rem;\r\n    }\r\n    .appBar{\r\n        padding: 20px 20px 0px 20px;\r\n    }\r\n    .logo {\r\n        width: 4.5rem;\r\n        height: 1.5rem;\r\n    }\r\n}\r\n\r\n@media (min-width: 771px) {\r\n    .menu {\r\n        display: none;\r\n    }\r\n    .list {\r\n        display: flex;\r\n        flex-grow: 1;     \r\n    }\r\n\r\n    .listItem {\r\n        margin-left: 2.5rem;\r\n        margin-top: 1.5rem;\r\n        margin-bottom: 1rem;\r\n        color: #f7f6f6;\r\n        font-size: 1rem;\r\n        font-style: normal;\r\n        font-weight: 500;\r\n    }\r\n  \r\n    .subListItem{\r\n        margin-left: 2.5rem;\r\n        margin-top: 1.5rem;\r\n        margin-bottom: 1rem;\r\n        color: #f7f6f6;\r\n        font-size: 0.5rem;\r\n        font-style: normal;\r\n        font-weight: 500;\r\n    }\r\n    .listItem:active, .listItem:hover, .listItem:focus, .listItemMenu:active, .listItemMenu:hover, .listItemMenu:focus {\r\n        color: #4fcdff;\r\n    }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"appBar": `navBar_appBar__B81wD`,
	"toolBar": `navBar_toolBar__jHcgH`,
	"logo": `navBar_logo__VE1zO`,
	"listItemMenu": `navBar_listItemMenu__Ciq+W`,
	"listItem": `navBar_listItem__2TkeY`,
	"subListItem": `navBar_subListItem__ns4hH`,
	"menuContainer": `navBar_menuContainer__6EM2v`,
	"image": `navBar_image__01ctI`,
	"list": `navBar_list__BpLCf`,
	"menu": `navBar_menu__f-fuw`
};
export default ___CSS_LOADER_EXPORT___;
